/**
 * GalleryDetailPage - Default wrapper for gallery detail view.
 *
 * Router Structure:
 * This component renders GalleryLayout which contains an Outlet.
 * The child routes (overview, review, job, export) are defined in App.tsx and rendered
 * through that Outlet.
 *
 * @see /src/features/gallery/layouts/GalleryLayout.tsx - New V2 layout with Outlet
 * @see /src/App.tsx - Route configuration with nested children
 */

import GalleryLayout from '@/features/gallery/layouts/GalleryLayout'

export default function GalleryDetailPage() {
  return <GalleryLayout />
}
